//import ApiService from "@/core/services/api.service";
import ApiService from "@/core/services/bbapi.service";
import JwtService from "@/core/services/jwt.service";

// action types
export const VERIFY_AUTH = "verifyAuth";
export const LOGIN = "login";
export const LOGOUT = "logout";
export const REGISTER = "register";
export const UPDATE_USER = "updateUser";

// mutation types
export const PURGE_AUTH = "logOut";
export const SET_AUTH = "setUser";
export const SET_ERROR = "setError";

const state = {
    errors: null,
    user: {},
    isAuthenticated: false
};
//!!  isAuthenticated: JwtService.getToken()

const getters = {
    currentUser(state) {
        return state.user;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    }
};

const actions = {
    [LOGIN](context, credentials) {
        return new Promise(resolve => {
            ApiService.post("login", credentials)
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                });
        });
    },
    [LOGOUT](context) {
        context.commit(PURGE_AUTH);
    },
    [REGISTER](context, credentials) {
        return new Promise((resolve, reject) => {
            ApiService.post("users", { user: credentials })
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject(response);
                });
        });
    },
    [VERIFY_AUTH](context) {

        return new Promise((resolve, reject) => {
            ApiService.get("/User/VerifyAuth")
                .then(({ data }) => {
                    context.commit(SET_AUTH, data);
                    resolve(data);
                })
                .catch(({ response }) => {
                    context.commit(SET_ERROR, response.data.errors);
                    reject(response);
                });
        });

        ////set dummy user data - must be used in layout pages somewhere?otherwise throws error
        //var user = JSON.parse(localStorage.getItem("UserPermissions"));
        //context.commit(SET_AUTH, user);


        //if (JwtService.getToken()) {
        //  ApiService.setHeader();
        //  ApiService.get("verify")
        //    .then(({ data }) => {
        //      context.commit(SET_AUTH, data);
        //    })
        //    .catch(({ response }) => {
        //      context.commit(SET_ERROR, response.data.errors);
        //    });
        //} else {
        //  context.commit(PURGE_AUTH);
        //}
    },
    [UPDATE_USER](context, payload) {
        const { email, username, password, image, bio } = payload;
        const user = { email, username, bio, image };
        if (password) {
            user.password = password;
        }

        return ApiService.put("user", user).then(({ data }) => {
            context.commit(SET_AUTH, data);
            return data;
        });
    }
};

const mutations = {
    [SET_ERROR](state, error) {
        state.errors = error;
    },
    [SET_AUTH](state, user) {
        state.isAuthenticated = user.isAuthenticated;
        state.environment = user.Environment;
        state.user = user;
        state.errors = {};
        //JwtService.saveToken(state.user);
    },
    [PURGE_AUTH](state) {
        state.isAuthenticated = false;
        state.user = {};
        state.errors = {};
        //JwtService.destroyToken();
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
